<div class="animate-pulse">
	{#each { length: 4 } as _}
		<div class="mb-2 h-10 rounded bg-gray-200"></div>
	{/each}
</div>
